import React, { useState, useRef, useEffect } from 'react';
import './EmojiPicker.css';

const COMMON_EMOJIS = [
  '😀', '😃', '😄', '😁', '😊', '😉', '😍', '🥰', '😘', '😗',
  '😙', '😚', '🙂', '🤗', '🤩', '🤔', '🤨', '😐', '😑', '😶',
  '🙄', '😏', '😣', '😥', '😮', '🤐', '😯', '😪', '😫', '😴',
  '😆', '😂', '😅', '😭', '🤤', '🤮', '🫡', '🫂', '🤦‍♂️', '👀',
  '👍', '👎', '👌', '✌️', '🤞', '🤝', '👏', '🙌', '🤲', '🙏',
  '🤘', '☝️', '👋', '🤌', '💅', '💪', '✨', '🎉', '🎊', '🎈',
  '🎁', '🏆', '🥇', '🥈', '🥉', '💯', '🔥', '✅', '🚬', '🚨',
  '📦', '💰', '💀', '🚀', '❓', '💎', '🍻', '‼️',
  '❤️', '🧡', '💛', '💚', '💙', '💜', '🤍', '🖤', '💔', '❣️',
];

interface Props {
  onEmojiSelect: (emoji: string) => void;
  onClose: () => void;
  buttonRef: React.RefObject<HTMLButtonElement | null>;
}

export const EmojiPicker: React.FC<Props> = ({ onEmojiSelect, onClose, buttonRef }) => {
  const pickerRef = useRef<HTMLDivElement>(null);
  const [position, setPosition] = useState<'above' | 'below'>('below');

  useEffect(() => {
    // Determine position based on available space
    if (buttonRef.current && pickerRef.current) {
      const buttonRect = buttonRef.current.getBoundingClientRect();
      const spaceBelow = window.innerHeight - buttonRect.bottom;
      const spaceAbove = buttonRect.top;
      const pickerHeight = 200;

      setPosition(spaceBelow < pickerHeight && spaceAbove > spaceBelow ? 'above' : 'below');
    }

    // Click outside to close
    const handleClickOutside = (e: MouseEvent) => {
      if (
        pickerRef.current &&
        !pickerRef.current.contains(e.target as Node) &&
        buttonRef.current &&
        !buttonRef.current.contains(e.target as Node)
      ) {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [onClose, buttonRef]);

  return (
    <div
      ref={pickerRef}
      className={`emoji-picker ${position}`}
    >
      <div className="emoji-grid">
        {COMMON_EMOJIS.map((emoji, index) => (
          <button
            key={index}
            className="emoji-button"
            onClick={() => {
              onEmojiSelect(emoji);
              onClose();
            }}
          >
            {emoji}
          </button>
        ))}
      </div>
    </div>
  );
};
